<script>
    import Bowser from "bowser";
    export default {
        props: {
            oldType: {
                type: String,
                default: '',
            },
            oldEmailClient: {
                type: String,
                default: 'Select',
            },
        },
        data: function () {
            return {
                driftLoaded: false,
                type: '',
                email_client: 'Select',
                browser: '',
                operating_system: '',
            }
        },
        mounted: function() {
            this.type = this.oldType;
            this.email_client = this.oldEmailClient;
            var bowser_data = Bowser.parse(window.navigator.userAgent);
            if (bowser_data.hasOwnProperty('browser') && bowser_data.browser.hasOwnProperty('version')) {
                this.browser = bowser_data.browser.name + " " + bowser_data.browser.version;
            }
            if (bowser_data.hasOwnProperty('os') && bowser_data.os.hasOwnProperty('version')) {
                this.operating_system = bowser_data.os.name + " " + bowser_data.os.version;
            }
        }
    }
</script>
